import { iSelectGame, iGameModel, iSelectGameType, iVirtualKeyboard, iGameAccount, iGameTimesLimit } from '@/interface/game-manage';
import request from '@/utils/request';
/**
 * 游戏列表
 * @param params
 */
export const getGameManage = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/game',
  });

/**
 * 新增游戏
 * @param data
 */
export const postAddGame = (data: iGameModel): Promise<any> =>
  request({
    url: '/api/v1/omc/game',
    method: 'post',
    data,
  });
/**
 * 修改游戏
 * @param data
 */
export const UpdateGame = (data: iGameModel): Promise<any> =>
  request({
    url: '/api/v1/omc/game',
    method: 'PUT',
    data,
  });
/* 新增游戏类别 */
export const postAddGameType = (data: iSelectGameType): Promise<any> =>
  request({
    url: '/api/v1/omc/game/category',
    method: 'post',
    data,
  });
/* 游戏类别 */
export const getGameType = (): Promise<any> =>
  request({
    url: '/api/v1/omc/game/category',
  });

/**
 * 游戏账号列表
 * @param params
 */
export const getGameTypeList = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/game/category',
  });

/* 虚拟键盘 */
export const getVirtualKeyboard = (params: iVirtualKeyboard): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/key_handle/list',
  });
/**
 * 游戏账号列表
 * @param params
 */
export const getGameAccountList = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/game/account',
  });

/* 删除游戏 */

export const delGame = (aid: any) => {
  return request({
    url: `/api/v1/omc/game/delete/${aid}`,
    method: 'delete',
  });
};
/* 删除游戏账号 */

export const delGameAccount = (aid: any) => {
  return request({
    url: `/api/v1/omc/game/account/${aid}`,
    method: 'delete',
  });
};
/* 修改游戏账号 */
export const postUpdateGameAccount = (data: iGameAccount): Promise<any> =>
  request({
    url: `/api/v1/omc/game/account/${data.id}`,
    method: 'PUT',
    data,
  });

/* 修改游戏账号 */
export const updateTimesLimit = (data: iGameTimesLimit): Promise<any> =>
  request({
    url: `/api/v1/omc/game/account/times_limit`,
    method: 'PUT',
    data,
  });
/* 导入游戏账号 */
export const postAddGameAccount = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/account/import',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
/* 导入缓存文件 */
export const postAddGameFile = (data: any): Promise<any> =>
  request({
    url: process.env.VUE_APP_BASE_FILE_API + '/upload_server/up_file',
    method: 'put',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
/**
 * 删除游戏类型
 * @param params
 */
export const delGameType = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/release',
    method: 'put',
  });

/**
 * 发布游戏类型
 * @param params
 */
export const setGameTypeRelease = () =>
  request({
    url: '/api/v1/omc/game/hot/release',
    method: 'put',
  });
/**
 * 游戏类型排序
 * @param params
 */
export const setGameTypeSort = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/sort',
    method: 'put',
    data,
  });

/* 刷新缓存 */

export const goRefreshCache = () => {
  return request({
    url: `/api/v1/omc/game/search/refresh`,
    method: 'put',
  });
};

/* 获取小区 */

export const getAreaSamll = () => {
  return request({
    url: `/api/v1/omc/area_small`,
  });
};
